import { useSelector } from "react-redux";
import CircularProgress from "@mui/material/CircularProgress";

const CLoader = ({ size = "medium", local = false }) => {
  const { loading } = useSelector((state) => state.common);
  
  const getSize = () => {
    switch (size) {
      case "small":
        return 20;
      case "large":
        return 40;
      default:
        return 24;
    }
  };

  const getContainerStyle = () => {
    if (local) {
      return {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "10px",
      };
    }
    
    return {
      position: "fixed",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(255, 255, 255, 0.8)",
      zIndex: 99999999,
    };
  };

  // If it's a local loader, always show it
  if (local) {
    return (
      <div style={getContainerStyle()}>
        <CircularProgress size={getSize()} />
      </div>
    );
  }

  // For global loader, check the loading state
  return (
    <>
      {loading && (
        <div style={getContainerStyle()}>
          <CircularProgress size={getSize()} />
        </div>
      )}
    </>
  );
};

export default CLoader;
